module.exports = __webpack_public_path__ + "static/media/promo-nglb.8023a32e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/promo-nglb.jpg
// module id = 1188
// module chunks = 0